export function getShortStoreName(value) {
    if (value) {
      return value.split(' ', 2).map((word) => word.charAt(0).toUpperCase()).join('');
    }
    return '';
  }